import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TextField, SelectField } from '../../atoms';
import { Row, Col, Spin, Button } from 'antd';
import { FormActions } from '../../components';
import {
  FORM_REGISTER_CONTACT,
  formRegisterContactFields,
} from '../../constants/formRegister';
import {
  addLegalEntityContact,
  updateLegalEntityContact,
} from '../../actions/actionCreators/registerContactsActionCreators';
import * as selectors from '../../reducers/registerContactsReducer';
import { phoneCodes } from '../../utils/phoneCodes';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { parseCharAndSpace } from '../../utils/formHelpers';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import validateSchema from './validateSchema';
import FormStateToRedux from '../FormStateToRedux';
import isEqual from 'lodash/isEqual';
import './RegisterContact.css';

const codes = phoneCodes.map((item) => ({ value: item, label: item }));

class RegisterContact extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    t: PropTypes.func.isRequired,
    addLegalEntityContact: PropTypes.func.isRequired,
    updateLegalEntityContact: PropTypes.func.isRequired,
  };

  onSubmit = async (values) => {
    const result = values[formRegisterContactFields.ID]
      ? await this.props.updateLegalEntityContact(values)
      : await this.props.addLegalEntityContact(values);
    if (!result?.error) {
      this.props.closeModal();
    }
  };

  render() {
    const { t, isLoading, initialValues } = this.props;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Form
        onSubmit={this.onSubmit}
        validate={validate}
        initialValues={initialValues}
        initialValuesEqual={isEqual}
        render={({ handleSubmit }) => (
          <Spin spinning={isLoading}>
            <form className="form-register-contact" onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_REGISTER_CONTACT} />
              <Row gutter={32}>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={formRegisterContactFields.CONTACT_PERSON}
                    component={TextField}
                    type="text"
                    placeholder={t('contact.contact_person_placeholder')}
                    label={t('contact.contact_person_label')}
                    parse={parseCharAndSpace}
                    required
                  />
                </Col>
                <Col className="gutter-row" span={12}>
                  <Row gutter={1}>
                    <Col span={4}>
                      <Field
                        label={t('contact.phone_label')}
                        name={formRegisterContactFields.PHONE_CODE}
                        component={SelectField}
                        options={codes}
                        hasFeedback={false}
                        required
                      />
                    </Col>
                    <Col span={20}>
                      <Field
                        colon={false}
                        name={formRegisterContactFields.PHONE}
                        component={TextField}
                        type="text"
                        label=" "
                        placeholder={t('contact.phone_placeholder')}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={32}>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={formRegisterContactFields.EMAIL}
                    component={TextField}
                    type="text"
                    placeholder={t('contact.email_placeholder')}
                    label={t('contact.email_label')}
                    required
                  />
                </Col>
              </Row>
              <FormActions>
                <Button size="large" type="primary" htmlType="submit">
                  {t('contact.save')}
                </Button>
              </FormActions>
            </form>
          </Spin>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const isLoading = getLoadingSelector(
    selectors.getEntityContactsAddState,
    selectors.getEntityContactsDeleteState
  )(state);
  return {
    isLoading,
  };
};

const mapDispatchToProps = {
  addLegalEntityContact,
  updateLegalEntityContact,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContact);
